export interface GooglePlaceAddress {
  formatted_address: string;
  place_id?: string;
  name?: string;
  viewport?: google.maps.LatLngBoundsLiteral;
}

export interface GooglePlaceOptions {
  componentRestrictions?: { country: string | string[] };
  bounds?: google.maps.LatLngBounds;
  strictBounds?: boolean;
  types?: string[];
}

export function toPlaceAutocompleteOptions(
  options: GooglePlaceOptions = {}
): google.maps.places.PlaceAutocompleteElementOptions {
  const mapped: google.maps.places.PlaceAutocompleteElementOptions = {};

  if (options.componentRestrictions?.country) {
    const countries = Array.isArray(options.componentRestrictions.country)
      ? options.componentRestrictions.country
      : [options.componentRestrictions.country];
    mapped.includedRegionCodes = countries.map(country => country.toLowerCase());
  }

  if (options.bounds) {
    if (options.strictBounds) {
      mapped.locationRestriction = options.bounds;
    } else {
      mapped.locationBias = options.bounds;
    }
  }

  if (options.types?.length) {
    mapped.includedPrimaryTypes = options.types;
  }

  return mapped;
}
